<template>
  <div>
    <div class="row">
      <!-- ============================================= -->
      <!-- الجانب الأيمن: أرقام الجلوس والمجموعات -->
      <!-- ============================================= -->
      <div class="col-sm-6 mobile-inputs">
        <h4 class="sub-title text-right">أرقام الجلوس والمجموعات</h4>

        <div class="form-group">
          <div class="row">
            <!-- إعدادات الجلوس الأصغر -->
            <div class="col-sm-6 mb-3">
              <label>بداية الجلوس الأصغر</label>
              <input 
                type="number" 
                v-model.number="form.min_seat_number_start" 
                @input="recalculateAll" 
                class="form-control" 
                required 
                placeholder="مثال: 1"
              />
            </div>
            <div class="col-sm-6 mb-3">
              <label>نهاية الجلوس الأصغر</label>
              <input type="number" :value="calculated_min_seat_number_end" disabled class="form-control" />
            </div>

            <!-- إعدادات الجلوس الأكبر -->
            <div class="col-sm-6 mb-3">
              <label>بداية الجلوس الأكبر</label>
              <input 
                type="number" 
                v-model.number="form.max_seat_number_start" 
                @input="recalculateAll" 
                class="form-control" 
                required 
                placeholder="مثال: 5001"
              />
            </div>
            <div class="col-sm-6 mb-3">
              <label>نهاية الجلوس الأكبر</label>
              <input type="number" :value="calculated_max_seat_number_end" disabled class="form-control" />
            </div>

            <!-- رقم المجموعة -->
            <div class="col-sm-6 mb-3">
              <label>رقم المجموعة</label>
              <input 
                type="text" 
                v-model="form.group_number" 
                @input="recalculateAll" 
                class="form-control" 
                required 
                placeholder="مثال: 55" 
              />
            </div>
            <div class="col-sm-6 mb-3">
              <label>الرقم السري</label>
              <input type="text" v-model="form.suc_no" class="form-control" />
            </div>
          </div>
        </div>

        <hr>

      </div>

      <!-- ============================================= -->
      <!-- الجانب الأيسر: الرقم السري (آلي) -->
      <!-- ============================================= -->
      <div class="col-sm-6 mobile-inputs bg-light-section">
        <h4 class="sub-title text-right">الأرقام السرية</h4>
        <p class="text-muted small">معادلة السري: (رقم المجموعة) + (أول 3 أرقام من اليسار للجلوس)</p>
        
        <div class="d-grid gap-2 mt-4 mb-4">
          <button @click.prevent="StoreNumber" class="btn btn-primary btn-lg">حفظ الترقيم</button>
          <button @click.prevent="initializeNumberRanges(20)" class="btn btn-secondary btn-lg">إعادة تهيئة (20 صف)</button>
        </div>

        <h5 class="text-center mb-3">نطاق السري المقابل</h5>
        
       
      </div>




              <div class="col-12">

        <h5 class="text-center mb-3">توزيع اللجان (نظام ملء الفراغات)</h5>
        


     <!-- عناوين الأعمدة (اختياري لزيادة التوضيح) -->
          <div class="row text-center small text-muted mb-1 d-none d-md-flex">
            <div class="col-1">م</div>
            <div class="col">بداية جلوس</div>
            <div class="col">نهاية جلوس</div>
            <div class="col">بداية سري</div>
            <div class="col">نهاية سري</div>
            <div class="col-1">حذف</div>
          </div>

          <!-- صفوف البيانات -->

          <div class="form-group row align-items-center g-2 mb-2" v-for="(range, index) in numbers" :key="'seat-' + index">
            
            <!-- 1. الترقيم (مساحة صغيرة) -->
            <div class="col-1">
              <div class="d-flex align-items-center justify-content-center fw-bold bg-light rounded border h-100 py-2">
                {{ index + 1 }}
              </div>
            </div>

            <!-- 2. بداية الجلوس (مساحة مرنة) -->
            <div class="col">
              <input 
                type="number" 
                v-model.number="range.start" 
                @input="updateRowSecret(index)" 
                required 
                class="form-control text-center" 
                placeholder="بداية جلوس" 
              />
            </div>

            <!-- 3. نهاية الجلوس -->
            <div class="col">
              <input 
                type="number" 
                v-model.number="range.end" 
                class="form-control text-center" 
                placeholder="نهاية جلوس" 
              />
            </div>

            <!-- 4. بداية السري (للقراءة فقط) -->
            <div class="col">
              <input 
                type="number" 
                v-model.number="range.sucstart" 
                class="form-control text-center bg-white text-primary fw-bold border-primary" 
                placeholder="بداية سري" 
                readonly 
              />
            </div>

            <!-- 5. نهاية السري (للقراءة فقط) -->
            <div class="col">
              <input 
                type="number" 
                v-model.number="range.sucend" 
                class="form-control text-center bg-white text-primary fw-bold border-primary" 
                placeholder="نهاية سري" 
                readonly 
              />
            </div>

            <!-- 6. زر الحذف (مساحة صغيرة) -->
            <div class="col-1">
              <button @click.prevent="deleteNumberRange(index)" class="btn btn-danger w-100 px-0">
                <i class="fas fa-times"></i>
              </button>
            </div>

          </div>

                  <div class="d-flex justify-content-between mt-3">
                    <button @click.prevent="addNumberRange(null)" class="btn btn-success">إضافة صف</button>
                    <button @click.prevent="clearAllNumberRanges" class="btn btn-warning">مسح الكل</button>
                  </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import api from '@/api/axios';

export default {
  data() {
    return {
      numbers: [], 
      form: {
        min_seat_number_start: null, // بداية الجلوس الأصغر
        max_seat_number_start: null, // بداية الجلوس الأكبر
        group_number: '',      
        sub_group_number: '',  
        security_number_start: '', 
      },
      message: '' 
    };
  },
  created() {
    // this.initializeNumberRanges(20);
  },
  computed: {
    calculated_min_seat_number_end() {
      return (this.form.min_seat_number_start) ? this.form.min_seat_number_start + 99 : null;
    },
    calculated_max_seat_number_end() {
      return (this.form.max_seat_number_start) ? this.form.max_seat_number_start + 99 : null;
    }
  },
  methods: {
    recalculateAll() {
      if (this.numbers.length > 0) {
        const currentCount = this.numbers.length;
        this.initializeNumberRanges(currentCount);
      }
    },

    initializeNumberRanges(count) {
      this.numbers = []; 
      for (let i = 0; i < count; i++) {
        this.addNumberRange(i); 
      }
    },

    // ========================================================
    // الدالة المعدلة لتطبيق الترتيب الدقيق (1-10، 5011-5020...)
    // ========================================================
    addNumberRange(initialIndex = null) {
      const index = initialIndex !== null ? initialIndex : this.numbers.length;
      
      const chunkSize = 10; // حجم الزيادة
      const cycleSize = 20; // طول الدورة (20 صف)
      
      // نحدد موقعنا داخل الـ 20 صف (0 إلى 19)
      const pos = index % cycleSize;
      
      let startValue = 0;
      let offset = 0;
      let isSmallRange = false;

      // === تطبيق المعادلة ===
      if (pos < 10) {
        // --- النصف الأول (الصفوف 0-9) ---
        // الزيادة: 0، 10، 20، 30... (index * 10)
        offset = pos * chunkSize;
        
        // التوزيع: زوجي -> صغير، فردي -> كبير
        if (pos % 2 === 0) {
            isSmallRange = true; // الصفوف 0, 2, 4, 6, 8 (صغير)
        } else {
            isSmallRange = false; // الصفوف 1, 3, 5, 7, 9 (كبير)
        }

      } else {
        // --- النصف الثاني (الصفوف 10-19) ---
        // الزيادة: نبدأ من 0 مجدداً، 10، 20... ((index - 10) * 10)
        offset = (pos - 10) * chunkSize;

        // التوزيع: زوجي -> كبير، فردي -> صغير (عكس النصف الأول)
        if (pos % 2 === 0) {
            isSmallRange = false; // الصفوف 10, 12, 14... (كبير)
        } else {
            isSmallRange = true; // الصفوف 11, 13, 15... (صغير)
        }
      }

      // === تحديد القيمة بناءً على النوع ===
      if (isSmallRange) {
        if (this.form.min_seat_number_start) {
          startValue = this.form.min_seat_number_start + offset;
        }
      } else {
        if (this.form.max_seat_number_start) {
          startValue = this.form.max_seat_number_start + offset;
        }
      }
      
      // نهاية النطاق
      const endValue = startValue + (chunkSize - 1);

      // إنشاء الكائن
      const newRange = { 
        start: startValue, 
        end: endValue,
        sucstart: 0,
        sucend: 0
      };

      // حساب السري
      const secrets = this.calculateSecretForRange(startValue);
      newRange.sucstart = secrets.start;
      newRange.sucend = secrets.end;

      this.numbers.push(newRange); 
    },

    calculateSecretForRange(seatStart) {
      if (!seatStart || !this.form.group_number) return { start: 0, end: 0 };

      let seatStr = String(seatStart);
      let firstThreeDigits = seatStr.length >= 3 ? seatStr.substring(0, 3) : seatStr;

      let secretStartStr = String(this.form.group_number) + firstThreeDigits;
      let secretStart = parseInt(secretStartStr);
      let secretEnd = secretStart + 9;

      return { start: secretStart, end: secretEnd };
    },

    updateRowSecret(index) {
      const row = this.numbers[index];
      const secrets = this.calculateSecretForRange(row.start);
      row.sucstart = secrets.start;
      row.sucend = secrets.end;
      row.end = row.start + 9;
    },

    deleteNumberRange(index) {
      this.numbers.splice(index, 1);
    },

    clearAllNumberRanges() {
        this.numbers = [];
    },

    StoreNumber() {
      if (!this.form.min_seat_number_start || !this.form.max_seat_number_start) {
        alert('الرجاء إدخال أرقام الجلوس (الأصغر والأكبر) أولاً.');
        return;
      }
      
      const dataToSend = {
        formDetails: {
            ...this.form,
            min_seat_number_end: this.calculated_min_seat_number_end,
            max_seat_number_end: this.calculated_max_seat_number_end
        },
        seatNumberRanges: this.numbers 
      };

      console.log('Sending:', dataToSend);
      
      api.post('/admin/StoreNumber', dataToSend)
        .then(res => {
            alert(res.data.message || 'تم الحفظ بنجاح');
        })
        .catch(err => {
            console.error(err);
            alert('حدث خطأ أثناء الحفظ');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-inputs {
  padding: 15px;
  border-right: 1px solid #dee2e6;
}
.mobile-inputs:last-child {
  border-right: none;
}
.sub-title {
  margin-bottom: 20px;
  color: #0d6efd;
  font-weight: bold;
  border-bottom: 2px solid #0d6efd;
  display: inline-block;
  padding-bottom: 5px;
}
.bg-light-section {
    background-color: #f8f9fa;
}
input[readonly] {
    background-color: #e9ecef !important;
    cursor: not-allowed;
    border: 1px solid #ced4da;
}
</style>